import { ENVIRONMENT } from './../../../environments/environment';
import { IAdapterMfListPort } from '../../domain/ports/i-adapter-mf-list';
import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import { MfListResponse } from 'src/app/domain/models/mf-list.model';

/**
 * Create Http Request (Get, Post, Delete, etc...)
 *
 * About Map: If the DTO is no equals to Model, you need format array.
 *
 */

@Injectable({
  providedIn: 'root',
})

export class MfListAdapterService implements IAdapterMfListPort{
  public path = ENVIRONMENT.urls.api;

  constructor(private http: HttpClient) {}

  getMfList(idCommerce: string, idRole:string): Observable<MfListResponse> {
    const url = `${this.path}/module/config/commerce/${idCommerce}?id_role=${idRole}`;
    return this.http.get<MfListResponse>(url)
  }

}
